import { useSyncExternalStore } from "react";

/**
 * The "what is still missing" summary lives at the bottom of CustomerDetailsForm, but the button
 * it explains — the dead Next / Submit — belongs to whoever renders the form. In the checkout the
 * two are not even in the same subtree: TotalAndCtaComponent sits beside the page, not inside it.
 * A context would have to be hoisted above both at all six submit sites, so the reveal is kept in
 * a module-level flag instead. Only one details form is ever on screen at a time.
 */
let revealed = false;
const listeners = new Set<() => void>();

function publish() {
    listeners.forEach((listener) => listener());
}

/** The visitor reached for the button that is not working. Now the summary earns its place. */
export function revealValidationSummary() {
    if (revealed) return;
    revealed = true;
    publish();
}

/** A fresh form starts quiet again — reaching for the button on a previous step means nothing here. */
export function resetValidationSummaryReveal() {
    if (!revealed) return;
    revealed = false;
    publish();
}

function subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}

export function useValidationSummaryRevealed(): boolean {
    return useSyncExternalStore(subscribe, () => revealed, () => false);
}
